var map = {
	"./1.png": 7164,
	"./2.png": 7909,
	"./3.png": 6078,
	"./4.png": 710,
	"./5.png": 6910,
	"./6.png": 8847,
	"./7.jpg": 9223,
	"./8.jpg": 9419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;